<div
  *ngIf="
    ingredientSearchResult$ | async as ingredientSearchResult;
    else waitingOnData
  "
>
  <div class="title-section">
    <p class="title text-heading">
      {{ 'i18n.menuProfitPro.addIngredient.recipes' | translate }}
    </p>
    <!-- <app-view-all-launcher
      [viewAllState]="viewAllState"
    >
    </app-view-all-launcher> -->
  </div>
  <div class="content">
    <div
      *ngFor="let result of ingredientSearchResult"
      class="click"
      (click)="selectIngredientToAdd(result)"
    >
      <div class="ingredient-search-result">
        <p>{{ result.name }}</p>
      </div>
    </div>
  </div>
  <ng-container
    *ngIf="(ingredientSearchResult ?? []).length === 0"
    [ngTemplateOutlet]="noResults"
  ></ng-container>
</div>

<ng-template #noResults>
  <p class="no-result">
    {{ 'i18n.menuProfitPro.addIngredient.noResults' | translate }}
  </p>
</ng-template>

<ng-template #waitingOnData>
  <div>
    <div class="title-section">
      <p class="title text-heading">
        {{ 'i18n.menuProfitPro.addIngredient.recipes' | translate }}
      </p>
      <!-- <app-view-all-launcher
        [viewAllState]="viewAllState"
      >
      </app-view-all-launcher> -->
    </div>
    <ng-container [ngTemplateOutlet]="noResults"></ng-container>
  </div>
</ng-template>
